import { createElementBlock as o, openBlock as t, createElementVNode as r } from "vue";
import n from "./index289.js";
const c = {}, l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(p, e, f, d, i, a) {
  return t(), o("svg", l, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 12.061C22 6.505 17.523 2 12 2S2 6.505 2 12.061c0 5.022 3.657 9.184 8.438 9.939v-7.03h-2.54v-2.91h2.54V9.845c0-2.522 1.492-3.915 3.777-3.915 1.094 0 2.238.197 2.238.197v2.476h-1.26c-1.243 0-1.63.775-1.63 1.57v1.888h2.773l-.443 2.908h-2.33V22c4.78-.755 8.437-4.917 8.437-9.939"
    }, null, -1)
  ]));
}
const _ = /* @__PURE__ */ n(c, [["render", s]]);
export {
  _ as default
};
